import { Flex, Spinner } from '@chakra-ui/react'

export default function LoadingOverlay() {
  return (
    <Flex
      data-testid="loading-overlay"
      aria-busy="true"
      minH="100vh"
      w="full"
      justify="center"
      align="center"
    >
      <Spinner size="xl" />
    </Flex>
  )
}
